import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { call, errText } from "@/lib/api";

const Ctx = createContext({ member: false, setMember: () => {}, refresh: async () => {}, logout: async () => {} });

export const postJson = async (path, body, method = "POST") => {
  const res = await call(path, { method, headers: { "Content-Type": "application/json" }, body: body ? JSON.stringify(body) : undefined });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(errText(data?.detail));
  return data;
};

/** member: null = checking, false = signed out, object = signed in */
export const AuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const res = await call("/members/me");
      setMember(res.ok ? await res.json() : false);
    } catch {
      setMember(false);
    }
  }, []);
  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);
  const logout = useCallback(async () => {
    await call("/members/logout", { method: "POST" });
    setMember(false);
  }, []);
  const value = useMemo(() => ({ member, setMember, refresh, logout }), [member, refresh, logout]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);

export const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/perfil";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
